import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
import { apiurl } from "../../../../../path";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import "./rejectpanel.css";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext";
import GooglePagination from "../../../styles/GooglePagination";
import { formatDateTime, formatDate } from '../../../../../utils/DateFormat';
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
const TechnicalSanctionInwards = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { GetTechnicalInwardsList, GetMyDepartmentAccess } = context;
  const [searchParams, setSearchParams] = useSearchParams();
  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(() => {
    const page = searchParams.get("page");
    return page ? parseInt(page) : 1;
  });
        const [exportingPDF, setExportingPDF] = useState(false);
        const [loading, setloading] = useState(false);

  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const nav = useNavigate();

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  //  const sortedBills = Array.isArray(filteredBills)
  //     ? filteredBills
  //   .slice() // ✅ prevent state mutation
  //   .sort((a, b) => new Date(b.Date) - new Date(a.Date))
  //     : [];
  const sortedBills = filteredBills;
  const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
        const displayedGRS = exportingPDF ? filteredBills : currentBills;

        const santionamount = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.TechnicalSanctionAmt );
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
    const pagesantionamount = currentBills?.reduce((sum, item) => {
    const amount = Number(item?.TechnicalSanctionAmt );
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);

  // addded for department filter
  const [myDepartments, setMyDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const parseDepartmentIds = (value) => {
    if (value === null || value === undefined || value === "") {
      return [];
    }
  
    if (Array.isArray(value)) {
      return value
        .map(Number)
        .filter((id) => Number.isInteger(id) && id > 0);
    }
  
    return String(value)
      .replace(/[\[\]"]/g, "")
      .split(",")
      .map((id) => Number(id.trim()))
      .filter((id) => Number.isInteger(id) && id > 0);
  };
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await GetMyDepartmentAccess();
  
        const departments = response?.data?.departments || [];
  
        setMyDepartments(departments);
  
        console.log("My Departments:", departments);
      } catch (error) {
        console.error("Department Fetch Error:", error);
        setMyDepartments([]);
      }
    };
  
    fetchDepartments();
  }, []);


  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    setSearchParams({ page: newPage });
  };
  const getTechnicalInwardsList = async () => {
    let data = await GetTechnicalInwardsList("All", "All");
    console.log("dataimvr", data);

    setTechnicalInwards(data);
    setFilteredBills(data);
  };
  useEffect(() => {
    getTechnicalInwardsList();
  }, []);

  let inwardList = [];
  if (technicalInwards.length > 0) {
    inwardList = technicalInwards;
  }
  // useEffect(() => {
  //   const lowerSearchTerm = searchTerm.toLowerCase();
  //   const filtered = technicalInwards.filter((bill) =>
  //     Object.values(bill).some((val) =>
  //       (val || "").toString().toLowerCase().includes(lowerSearchTerm),
  //     ),
  //   );
  //   setFilteredBills(filtered);
  //   // setCurrentPage(1); // Reset to page 1 on search
  // }, [searchTerm, technicalInwards]);
  useEffect(() => {
    let filtered = Array.isArray(technicalInwards)
      ? [...technicalInwards]
      : [];
    // Department Filter
    if (selectedDepartment !== "") {
      const departmentId = Number(selectedDepartment);
      filtered = filtered.filter((item) => {
        const departmentIds = parseDepartmentIds(
          item.DepartmentAccessID
        );
        return departmentIds.includes(departmentId);
      });
    }
    // Existing Search Filter
    if (searchTerm.trim() !== "") {
      const lowerSearchTerm = searchTerm.trim().toLowerCase();
      filtered = filtered.filter((bill) =>
        Object.values(bill).some((val) =>
          (val ?? "")
            .toString()
            .toLowerCase()
            .includes(lowerSearchTerm)
        )
      );
    }
    setFilteredBills(filtered);
    setCurrentPage(1);
    setSearchParams({ page: "1" });
  }, [technicalInwards, searchTerm, selectedDepartment]);


  useEffect(() => {
    const page = parseInt(searchParams.get("page")) || 1;
    if (totalPages > 0 && page > totalPages) {
      setCurrentPage(totalPages);
      setSearchParams({ page: totalPages });
    } else if (page < 1) {
      setCurrentPage(1);
      setSearchParams({ page: 1 });
    }
  }, [searchParams, totalPages, setSearchParams]);
const exportTableByClassToExcel = async (
  bills,
  filename = "Technical_Sanction_Approvals.xlsx",
) => {
  if (!bills || bills.length === 0) {
    alert("No data available");
    return;
  }

  setloading(true);

  await new Promise((resolve) => setTimeout(resolve, 500));

  try {
    const excelData = bills.map((technicalInwards, index) => ({
      "Sr. No.": index + 1,

      View: "View",

      Year: technicalInwards.SanctionYear || "",

      "Work Name": technicalInwards.WorkName || "",

      "Job ID": technicalInwards.JOB_ID || "",

      "MHUID Number": technicalInwards.TechnicalSanctionNo || "",

      "Sanction Amount": Number(
        technicalInwards.TechnicalSanctionAmt || 0
      ),

   
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);

    /* Column widths */
    worksheet["!cols"] = [
      { wch: 10 }, // Sr. No.
      { wch: 10 }, // View
      { wch: 12 }, // Year
      { wch: 40 }, // Work Name
      { wch: 20 }, // Job ID
      { wch: 22 }, // MHUID Number
      { wch: 18 }, // Sanction Amount
      { wch: 40 }, // Technical Sanction Copy
      { wch: 40 }, // GR Approved Copy
    ];

    /* Freeze header */
    worksheet["!freeze"] = {
      xSplit: 0,
      ySplit: 1,
    };

    /* Auto filter */
    worksheet["!autofilter"] = {
      ref: XLSX.utils.encode_range({
        s: { r: 0, c: 0 },
        e: {
          r: excelData.length,
          c: Object.keys(excelData[0]).length - 1,
        },
      }),
    };

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Technical Sanctions"
    );

    XLSX.writeFile(workbook, filename);

  } catch (error) {
    console.error("Excel Export Error:", error);
  } finally {
    setloading(false);
  }
};
  //   const downloadTableOnlyAsPDF = async (
  //   tableClass,
  //   filename,
  //   title,
  //   chunkSize = 500, // 🔥 300–500 recommended
  // ) => {
  //   const originalTable = document.querySelector(`.${tableClass}`);
  //   if (!originalTable) {
  //     setExportingPDF(false);
  //     return;
  //   }

  //   setloading(true);
  //   setExportingPDF(true);

  //   // Allow loader to render first
  //   await new Promise((resolve) => setTimeout(resolve, 600));

  //   try {
  //     const originalRows = originalTable.querySelectorAll("tbody tr");
  //     const totalRows = originalRows.length;

  //     if (!totalRows) {
  //       setloading(false);
  //       setExportingPDF(false);
  //       return;
  //     }

  //     for (let start = 0; start < totalRows; start += chunkSize) {
  //       const end = Math.min(start + chunkSize, totalRows);

  //       // 🔥 Clone table cleanly
  //       const tableClone = originalTable.cloneNode(true);
  //       const rows = tableClone.querySelectorAll("tbody tr");

  //       // Remove rows outside current chunk
  //       rows.forEach((row, index) => {
  //         if (index < start || index >= end) {
  //           row.remove();
  //         }
  //       });

  //       // Hide cloned table from view
  //       tableClone.style.position = "absolute";
  //       tableClone.style.left = "-9999px";
  //       tableClone.style.top = "0";
  //       document.body.appendChild(tableClone);

  //       const pdf = new jsPDF("p", "mm", "a4");
  //       const pageWidth = pdf.internal.pageSize.getWidth();
  //       const pageHeight = pdf.internal.pageSize.getHeight();

  //       const topMargin = 25;
  //       const sideMargin = 10;
  //       const bottomMargin = 15;

  //       pdf.setFontSize(16);
  //       pdf.setFont("helvetica", "bold");
  //       pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
  //         align: "center",
  //       });

  //       const canvas = await html2canvas(tableClone, {
  //         scale: 1,
  //         useCORS: true,
  //         backgroundColor: "#2C78DB",
  //       });

  //       const imgWidth = pageWidth - sideMargin * 2;
  //       const pxToMm = imgWidth / canvas.width;

  //       const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
  //       const usablePageHeightPx = usablePageHeightMm / pxToMm;

  //       let renderedHeight = 0;
  //       let pageNumber = 0;

  //       while (renderedHeight < canvas.height) {
  //         const sliceHeight = Math.min(
  //           usablePageHeightPx,
  //           canvas.height - renderedHeight,
  //         );

  //         const pageCanvas = document.createElement("canvas");
  //         const context = pageCanvas.getContext("2d");

  //         pageCanvas.width = canvas.width;
  //         pageCanvas.height = sliceHeight;

  //         context.drawImage(
  //           canvas,
  //           0,
  //           renderedHeight,
  //           canvas.width,
  //           sliceHeight,
  //           0,
  //           0,
  //           canvas.width,
  //           sliceHeight,
  //         );

  //         const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

  //         if (pageNumber > 0) pdf.addPage();

  //         pdf.addImage(
  //           imgData,
  //           "JPEG",
  //           sideMargin,
  //           topMargin,
  //           imgWidth,
  //           sliceHeight * pxToMm,
  //         );

  //         renderedHeight += sliceHeight;
  //         pageNumber++;
  //       }

  //       pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

  //       document.body.removeChild(tableClone);

  //       // Small delay prevents UI freezing
  //       await new Promise((resolve) => setTimeout(resolve, 300));
  //     }
  //   } catch (error) {
  //     console.error("PDF Export Error:", error);
  //   } finally {
  //     setExportingPDF(false);
  //     setloading(false);
  //   }
  // };
  
    const downloadTableOnlyAsPDF = async (
    tableClass,
    filename,
    title,
    chunkSize = 500
  ) => {
    const originalTable = document.querySelector(`.${tableClass}`);

    // Table itself not found
    if (!originalTable) {
      alert("No data available");
      setExportingPDF(false);
      setloading(false);
      return;
    }

    const headerCellsRef = Array.from(
      originalTable.querySelectorAll("thead tr th")
    );

    const headerColCount = headerCellsRef.length;

    // Get only actual data rows
    const allOriginalRows = Array.from(
      originalTable.querySelectorAll("tbody tr")
    );

    const originalRows = allOriginalRows.filter((row) => {
      const text = row.textContent.trim().toLowerCase();

      // Remove total rows
      if (text.includes("page total")) return false;
      if (text.includes("gross total")) return false;

      // Remove "no data" rows
      if (
        text.includes("no data") ||
        text.includes("no records") ||
        text.includes("no record") ||
        text.includes("data not found") ||
        text.includes("no results") ||
        text.includes("not found")
      ) {
        return false;
      }

      const cells = Array.from(row.querySelectorAll("td"));

      if (cells.length === 0) return false;

      // Check whether row actually contains meaningful data
      const hasRealData = cells.some((cell) => {
        const value = cell.textContent.trim();

        return (
          value !== "" &&
          value !== "-" &&
          value !== "—" &&
          value !== "N/A" &&
          value !== "NA"
        );
      });

      return hasRealData;
    });

    // Do this BEFORE setloading/setExportingPDF
    if (originalRows.length === 0) {
      alert("No data available");
      setExportingPDF(false);
      setloading(false);
      return;
    }

    // Start loader only after confirming data exists
    setloading(true);
    setExportingPDF(true);
    await new Promise((resolve) => setTimeout(resolve, 600));
    try {
      let amountColIndex = headerCellsRef.findIndex((th) =>
        th.textContent.trim().toLowerCase().includes("amount")
      );
      if (amountColIndex === -1) {
        amountColIndex = headerColCount - 3;
      }
      const totalRows = originalRows.length;
      let totalAmount = 0;
      originalRows.forEach((row) => {
        const cells = row.querySelectorAll("td");
        const amountCell = cells[amountColIndex];
        if (amountCell) {
          const amountText = amountCell.textContent
            .replace(/,/g, "")
            .replace(/[₹$]/g, "")
            .replace(/\s+/g, "")
            .trim();

          const amount = parseFloat(amountText);
          if (!isNaN(amount)) {
            totalAmount += amount;
          }
        }
      });
      for (let start = 0; start < totalRows; start += chunkSize) {
        const end = Math.min(start + chunkSize, totalRows);
        const tableClone = originalTable.cloneNode(true);
        tableClone.querySelectorAll("tbody tr").forEach((row) => {
          const text = row.textContent.trim().toLowerCase();
          if (
            text.includes("page total") ||
            text.includes("gross total")
          ) {
            row.remove();
          }
        });
        const clonedTbody = tableClone.querySelector("tbody");
        if (clonedTbody) {
          clonedTbody.innerHTML = "";
          for (let i = start; i < end; i++) {
            const clonedRow = originalRows[i].cloneNode(true);
            const firstCell = clonedRow.querySelector("td");
            if (firstCell) {
              firstCell.textContent = i + 1;
            }
            clonedTbody.appendChild(clonedRow);
          }
          if (end === totalRows) {
            const totalRow = document.createElement("tr");
            const totalLabelCell = document.createElement("td");
            totalLabelCell.textContent = "Total";
            totalLabelCell.style.fontWeight = "bold";
            totalLabelCell.style.textAlign = "right";
            totalLabelCell.colSpan = Math.max(amountColIndex, 1);
            totalRow.appendChild(totalLabelCell);
            const totalAmountCell = document.createElement("td");
            totalAmountCell.textContent =
              totalAmount.toLocaleString("en-IN", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
            totalAmountCell.style.fontWeight = "bold";
            totalAmountCell.style.textAlign = "right";
            totalRow.appendChild(totalAmountCell);
            const remainingCols = headerColCount - amountColIndex - 1;
            if (remainingCols > 0) {
              const emptyCell = document.createElement("td");
              emptyCell.colSpan = remainingCols;
              totalRow.appendChild(emptyCell);
            }
            clonedTbody.appendChild(totalRow);
          }
        }
        tableClone.style.position = "absolute";
        tableClone.style.left = "-9999px";
        tableClone.style.top = "0";
        tableClone.style.backgroundColor = "#ffffff";
        document.body.appendChild(tableClone);
        const pdf = new jsPDF("p", "mm", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const topMargin = 25;
        const sideMargin = 10;
        const bottomMargin = 15;
        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");
        pdf.text(
          `${title} (${start + 1} - ${end})`,
          pageWidth / 2,
          15,
          {
            align: "center",
          }
        );
        const canvas = await html2canvas(tableClone, {
          scale: 1,
          useCORS: true,
          backgroundColor: "#ffffff",
        });
        const imgWidth = pageWidth - sideMargin * 2;
        const pxToMm = imgWidth / canvas.width;
        const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
        const usablePageHeightPx = usablePageHeightMm / pxToMm;
        let renderedHeight = 0;
        let pageNumber = 0;
        while (renderedHeight < canvas.height) {
          const sliceHeight = Math.min(
            usablePageHeightPx,
            canvas.height - renderedHeight
          );
          const pageCanvas = document.createElement("canvas");
          const context = pageCanvas.getContext("2d");
          pageCanvas.width = canvas.width;
          pageCanvas.height = sliceHeight;
          context.fillStyle = "#ffffff";
          context.fillRect(
            0,
            0,
            pageCanvas.width,
            pageCanvas.height
          );
          context.drawImage(
            canvas,
            0,
            renderedHeight,
            canvas.width,
            sliceHeight,
            0,
            0,
            canvas.width,
            sliceHeight
          );
          const imgData = pageCanvas.toDataURL(
            "image/jpeg",
            0.85
          );
          if (pageNumber > 0) {
            pdf.addPage();
            pdf.setFontSize(16);
            pdf.setFont("helvetica", "bold");
            pdf.text(
              `${title} (${start + 1} - ${end})`,
              pageWidth / 2,
              15,
              {
                align: "center",
              }
            );
          }
          pdf.addImage(
            imgData,
            "JPEG",
            sideMargin,
            topMargin,
            imgWidth,
            sliceHeight * pxToMm
          );
          renderedHeight += sliceHeight;
          pageNumber++;
        }
        pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);
        if (document.body.contains(tableClone)) {
          document.body.removeChild(tableClone);
        }
        await new Promise((resolve) => setTimeout(resolve, 300));
      }
    } catch (error) {
      console.error("PDF Export Error:", error);
      alert("Error while generating PDF");
    } finally {
      setExportingPDF(false);
      setloading(false);
    }
  };
  
  return (
    <>
      <div
        className="col-12"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
        }}
      >
        <div className="col-12 px-3 m-auto">
       {/* <div
  className="col-12 px-4 mb-4 mt-3"
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  }}
>

  <h5 className="my-auto fw-bold">
    <img
      src="/GR-Approval64.png"
      alt="Technical Approval"
      style={{
        width: "24px",
        height: "24px",
      }}
      className="my-auto me-1"
    />
    <span className="my-auto">
      {t("Technical Sanction Inwards")}
    </span>
  </h5>


  <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "10px",
    }}
  >
     <div
      style={{
        position: "relative",
        width: "250px",
      }}
    >
      <img
        src="/Search32.png"
        alt="Search Icon"
        style={{
          position: "absolute",
          top: "50%",
          left: "10px",
          transform: "translateY(-50%)",
          width: "16px",
          height: "16px",
          opacity: 0.6,
          pointerEvents: "none",
        }}
      />

      <input
        type="text"
        placeholder={t("Search Here")}
        onChange={(e) => setSearchTerm(e.target.value)}
        value={searchTerm}
        style={{
          width: "100%",
          padding: "8px 12px 8px 32px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#f1f6fc",
          fontSize: "14px",
          color: "#333",
          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
          outline: "none",
        }}
      />
    </div>
   
    <button
      className="btn btn-success"
      style={{
        fontSize: "18px",
        fontWeight: "600",
      }}
      onClick={() =>
        exportTableByClassToExcel(
          filteredBills,
          "TechnicalApprovals.xlsx"
        )
      }
    >
      {t("Download Excel")}
    </button>


    <button
      className="btn btn-danger"
      style={{
        fontSize: "18px",
        fontWeight: "600",
      }}
      onClick={() =>
        downloadTableOnlyAsPDF(
          "TechnicalApprovals",
          "TechnicalApprovals.pdf",
          "Technical Approval List"
        )
      }
    >
      {t("Download PDF")}
    </button>

   
   
  </div>
</div> */}

<div
  className="col-12 px-4 mb-4 mt-3"
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "12px",
  }}
>
  {/* Title */}
  <h5 className="my-auto fw-bold">
    <img
      src="/GR-Approval64.png"
      alt="Technical Approval"
      style={{
        width: "24px",
        height: "24px",
      }}
      className="my-auto me-1"
    />
    <span className="my-auto">
      {t("Technical Sanction Inwards")}
    </span>
  </h5>

  {/* Right Side: Department + Search + Export Buttons */}
  <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "10px",
      flexWrap: "wrap",
    }}
  >
    {/* Department Filter */}
    {myDepartments.length > 1 && (
      <div style={{ width: "220px" }}>
        <select
          className="form-select"
          value={selectedDepartment}
          onChange={(e) =>
            setSelectedDepartment(e.target.value)
          }
          style={{
            width: "100%",
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            backgroundColor: "#fff",
            fontSize: "14px",
          }}
        >
          <option value="">
            {t("Select Department")}
          </option>

          {myDepartments.map((department) => (
            <option
              key={department.id}
              value={department.id}
            >
              {department.name}
            </option>
          ))}
        </select>
      </div>
    )}

    {/* Search Box */}
    <div
      style={{
        position: "relative",
        width: "250px",
      }}
    >
      <img
        src="/Search32.png"
        alt="Search Icon"
        style={{
          position: "absolute",
          top: "50%",
          left: "10px",
          transform: "translateY(-50%)",
          width: "16px",
          height: "16px",
          opacity: 0.6,
          pointerEvents: "none",
        }}
      />

      <input
        type="text"
        placeholder={t("Search Here")}
        onChange={(e) =>
          setSearchTerm(e.target.value)
        }
        value={searchTerm}
        style={{
          width: "100%",
          padding: "8px 12px 8px 32px",
          border: "1px solid #ccc",
          borderRadius: "8px",
          backgroundColor: "#f1f6fc",
          fontSize: "14px",
          color: "#333",
          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
          outline: "none",
        }}
      />
    </div>

    {/* Excel Button */}
    <button
      className="btn btn-success"
      style={{
        fontSize: "18px",
        fontWeight: "600",
        whiteSpace: "nowrap",
      }}
      onClick={() =>
        exportTableByClassToExcel(
          filteredBills,
          "TechnicalApprovals.xlsx"
        )
      }
    >
      {t("Download Excel")}
    </button>

    {/* PDF Button */}
    <button
      className="btn btn-danger"
      style={{
        fontSize: "18px",
        fontWeight: "600",
        whiteSpace: "nowrap",
      }}
      onClick={() =>
        downloadTableOnlyAsPDF(
          "TechnicalApprovals",
          "TechnicalApprovals.pdf",
          "Technical Approval List"
        )
      }
    >
      {t("Download PDF")}
    </button>
  </div>
</div>


          <div
            className="m-auto"
            style={{
              width: "98%",
              backgroundColor: "white",
              padding: "30px 30px",
              boxShadow: "0px 0px 5px 1px #c7c9cc",
              borderRadius: "20px",
            }}
          >
            <div
              className="col-12 tableDesign"
              style={{ background: "#2C78DB",overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative", }}
            >
              <table
                className="m-0 p-0 TechnicalApprovals"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead style={{ position: "sticky",  backgroundColor: "#1976d2",
                      top: 0,
                      zIndex: 10,}}>
                  <tr
                    style={{
                      color: "white",
                      border: "none",
                      height: "3rem",
                      fontSize: "18px",
                    }}
                  >
                    <th style={{ width: "5%", padding: '10px',fontSize:"18px" }}>{t("Sr. No.")}</th>
                    <th style={{ width: "5%", padding: "5px" ,fontSize:"18px"}}>{t("View")}</th>
                    <th style={{ width: "8%", padding: "5px" ,fontSize:"18px"}}>{t("Year")}</th>
                    <th style={{ width: "14%", padding: "5px" ,fontSize:"18px" }}>
                      {t("Work Name")}
                    </th>
                    <th style={{ width: "12%", padding: "8px",fontSize:"18px" }}>
                      {t("Job ID")}
                    </th>
                    <th style={{ width: "8%", padding: "5px",fontSize:"18px" }}>
                      {t("MHUID Number")}
                    </th>
                    {/* <th style={{ width: "8%", padding: '5px' }}>HeadCode</th> */}
                    {/* <th style={{ width: "8%", padding: '5px' }}>Zila Parishad</th> */}
                    <th style={{ width: "8%", padding: "5px",fontSize:"18px" }}>
                      {t("Sanction Amount")}
                    </th>
                    <th style={{ width: "8%", padding: "5px",fontSize:"18px" }}>
                      {t("Technical Sanction Copy")}
                    </th>
                    <th style={{ width: "8%", padding: "5px",fontSize:"18px" }}>
                      {t("GR Apprved Copy")}
                    </th>
                    {/* <th style={{ width: "8%", padding: '5px' }}>Date</th> */}
                    {/* <th style={{ padding: '8px' }}>Date</th> */}
                  </tr>
                </thead>
                <tbody>
                  {displayedGRS.length <= 0 ? (
                    <tr>
                      <td
                        colSpan="12"
                        style={{
                          textAlign: "center",
                          padding: "20px",
                          backgroundColor: "#f9f9f9",
                        }}
                      >
                        {t("No data available")}
                      </td>
                    </tr>
                  ) : (
                    displayedGRS?.map((technicalInwards, index) => {
                      const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                      return (
                        <tr
                          style={{
                            borderBottom: "1px solid #3b409e",
                            backgroundColor: bgColor,
                            fontWeight: "600",fontSize:"18px"
                          }}
                        >                 <td style={{ padding: '8px' }}>{indexOfFirstBill+index+1}</td>
                          <td style={{ padding: "8px" ,fontSize:"18px" }}>
                            <button
                              onClick={() =>
                                nav(
                                  `/AdminDashboard/TechnicalSanctionApprove/${technicalInwards.TS_ID}?page=${currentPage}`,
                                )
                              }
                              className="m-auto text-center"
                              style={{
                                width: "4rem",
                                fontWeight: "600",
                                padding: "7px 3px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "0.1rem",
                                background:
                                  "linear-gradient(to Right,#3547A1 ,#275BAD ,#1D6AB6 ,#068BCA)",
                                color: "white",
                                borderRadius: "8px",
                              }}
                            >
                              {" "}
                              <img
                                src="/view32.png"
                                style={{
                                  width: "0.9rem",
                                  height: "0.9rem",
                                  filter: "brightness(0) invert(1)",
                                }}
                              />
                              {t("View")}
                            </button>
                          </td>
                          <td style={{ padding: "8px",fontSize:"18px" }}>
                            {technicalInwards.SanctionYear}
                          </td>
                          <td style={{ padding: "8px" ,fontSize:"18px" }}>
                            {technicalInwards.WorkName}
                          </td>
                          <td style={{ padding: "8px",fontSize:"18px" }}>
                            {technicalInwards.JOB_ID}
                          </td>
                          <td style={{ padding: "8px" ,fontSize:"18px"}}>
                            {technicalInwards.TechnicalSanctionNo}
                          </td>
                          {/* <td style={{ padding: '8px' }}>{technicalInwards.TS_ID}</td> */}
                          {/* <td style={{ padding: '8px' }}>{technicalInwards.HeadCode}</td> */}
                          {/* <td style={{ padding: '8px' }}>{technicalInwards.District}</td> */}
                          <td style={{ padding: "8px",fontSize:"18px" }}>
                            {technicalInwards.TechnicalSanctionAmt}
                          </td>
                          <td className="px-1">
                            {technicalInwards.TechnicalSanctionCopy ? (
                              <div
                                className="m-auto"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.20rem",
                                  justifyContent: "center",
                                  width: "fit-content",
                                }}
                              >
                                <img
                                  src="/pdf-32.png"
                                  alt="pdf"
                                  style={{ width: "1.3rem", height: "1.3rem" }}
                                />
                                <a
                                  href={`${apiurl}/TechincalSactionCopy/${technicalInwards.TechnicalSanctionCopy}`}
                                  target="_blank"
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    color: "#357EDC",
                                    maxWidth: "8rem",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    textAlign: "justify",
                                  }}
                                  title={technicalInwards.TechnicalSanctionCopy}
                                >
                                  {technicalInwards.TechnicalSanctionCopy}
                                </a>
                              </div>
                            ) : (
                              <div
                                className="m-auto"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.20rem",
                                  justifyContent: "center",
                                  width: "fit-content",
                                }}
                              >
                                <img
                                  src="/No-File32.png"
                                  alt="no file"
                                  style={{ width: "1.3rem", height: "1.3rem" }}
                                />
                                <span className="text-danger fw-bold">
                                  No File
                                </span>
                              </div>
                            )}
                          </td>
                          <td style={{ padding: "8px" }}>
                            {technicalInwards.GRDraftCopy ? (
                              <>
                                {/* <a href={`${apiurl}/GRDraftCopy/${technicalInwards.GRDraftCopy}`} target='_blank'>
                                                                                {technicalInwards.GRDraftCopy}
                                                                            </a> */}

                                <div
                                  className="m-auto"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.20rem",
                                    justifyContent: "center",
                                    width: "fit-content",
                                  }}
                                >
                                  <img
                                    src="/pdf-32.png"
                                    alt="pdf"
                                    style={{
                                      width: "1.3rem",
                                      height: "1.3rem",
                                    }}
                                  />
                                  <a
                                    href={`${apiurl}/GRDraftCopy/${technicalInwards.GRDraftCopy}`}
                                    target="_blank"
                                    style={{
                                      fontSize: "18px",
                                      fontWeight: "600",
                                      color: "#357EDC",

                                      maxWidth: "130px",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      textAlign: "justify",
                                    }}
                                    title={technicalInwards.GRDraftCopy}
                                  >
                                    {technicalInwards.GRDraftCopy}
                                  </a>
                                </div>
                              </>
                            ) : (
                              <div
                                className="m-auto"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.20rem",
                                  justifyContent: "center",
                                  width: "fit-content",
                                }}
                              >
                                <img
                                  src="/No-File32.png"
                                  alt="no file"
                                  style={{ width: "1.3rem", height: "1.3rem" }}
                                />
                                <span className="text-danger fw-bold">
                                  {t("No File")}
                                </span>
                              </div>
                            )}
                          </td>
                          {/* <td>{new Date(technicalInwards.Date).toLocaleString()}</td> */}
                        </tr>
                      );
                    })
                  )}
                   <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0", textAlign:"right", padding:"4px"}}>
                                <td colSpan={6} style={{fontSize:"18px"}}>{t("Page Total")}</td>
                                <td style={{ padding:"4px" ,fontSize:"18px"}}>
                                  ₹{" "}
                                  {Number(
                                   pagesantionamount
                                  ).toLocaleString("en-IN")}
                                </td>
                                                                <td colSpan={2}></td>
                              </tr>
                              {/* Grand Total Row */}
                              <tr style={{ fontWeight: "bold", backgroundColor: "#f0f0f0" ,textAlign:"right" ,padding:"4px"}}>
                                <td colSpan={6}style={{fontSize:"18px"}}>{t("Gross Total")}</td>
                                <td style={{padding:"4px",fontSize:"18px"}}>
                                  ₹{" "}
                                  {Number(
santionamount                                  ).toLocaleString("en-IN")}
                                </td>
                                <td colSpan={2}></td>
                              </tr>
                </tbody>
              </table>
            </div>

            <div className="col-12 mt-3">
              <div className="row">
                <div className="col-6">
                  <p className="text-gray-600" style={{ fontSize: "18px" }}>
                    {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
                    {Math.min(indexOfLastBill, filteredBills.length)} {t("of")}{" "}
                    {technicalInwards.length} {t("entries")}
                  </p>
                </div>

                <div
                  className="col-6 text-end"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                  }}
                >
                  <GooglePagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
         {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255,255,255,0.4)",
              backdropFilter: "blur(2px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="Adminloader"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default TechnicalSanctionInwards;
